export default {
  loading: false,
  data: null,
  error: null,
  types: null,
  task: null,
};
